import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import MainRoutes from "./routes/MainRoutes.jsx";
import { ThemeContextProvider } from "./Components/context/theme.context.jsx";
import "./global.jsx";
import "animate.css";
import { isReady, navigationRef } from "./Navigations/RootNavigation.jsx";
import { AppContextProvider } from "./Components/context/app.context.jsx";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import ErrorBoundary from "./Components/Component/ErrorBoundary.jsx";
import ErrorPage from "./Components/Component/ErrorPage.jsx";
import { CartContextProvider } from "./Components/context/cartContext.jsx";

const App = () => {
  const user = useSelector((state) => state.user);
  global.$userData = user;
  const signIn = useSelector((data) => data.signinStatus);
  global.$signInStatus = signIn;

  const theme = createTheme({
    typography: {
      fontFamily: "Public Sans",
    },
  });

  useEffect(() => {
    isReady.current = false;
  }, []);

  return (
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <ThemeContextProvider
          ref={navigationRef}
          isReady={() => (isReady.current = true)}
        >
          <AppContextProvider>
            <CartContextProvider>
              <ErrorBoundary fallback={<ErrorPage />}>
                <MainRoutes />
              </ErrorBoundary>
            </CartContextProvider>
          </AppContextProvider>
        </ThemeContextProvider>
      </ThemeProvider>
    </React.StrictMode>
  );
};

export default App;
